// extracted by mini-css-extract-plugin
export default {"root":"SettingsSecurityAndLogin2FAConfirm_root__XxPV8"};